// Demo-only (am-tp-demo user groups) — delete after the TP demo. Not a real-feature surface.
import { fetcher } from '@commenda/utils';

export async function deleteAffiliateUserGroup(
  affiliateFirmId: string,
  groupId: string
): Promise<{ success: boolean; error?: string }> {
  try {
    const response = await fetcher(
      `demo/affiliate-firms/${affiliateFirmId}/user-groups/${groupId}`,
      {
        method: 'DELETE',
      }
    );

    if (!response.ok) {
      return { success: false, error: 'Could not delete the group.' };
    }

    return { success: true };
  } catch (error) {
    return { success: false, error: 'Could not delete the group.' };
  }
}
